import _, { unset } from 'lodash';
import * as React from 'react';
import { useParams, useHistory, useRouteMatch } from 'react-router-dom';
import { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import { LayerVisibility } from '../../../types/types';
import moment from 'moment';
import { useStore } from '../../../providers/AppProvider';
import { faPlay, faPause, faLayerGroup, faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Gradient from "../../../../../components/Gradient";
import Slider, { Range } from 'rc-slider';
import Tooltip from 'rc-tooltip';
import bbox from "@turf/bbox";
import { useFieldStore } from '../providers/FieldProvider';
import { SETTING_SEASON_YEAR } from '../../../utils/settings';
import { BillingGroupNameAndArnList } from 'aws-sdk/clients/iot';
import { LoadingSpinnerSmall } from '../../../../../components/LoadingSpinnerSmall';
import { timeline } from 'console';
import { color } from 'openlayers';
import { ButtonGroup, Dropdown, DropdownButton } from 'react-bootstrap';


interface ILayerControlProps {
  layers: LayerVisibility[],
  onChange: (v: LayerVisibility[]) => void,
  showDatePicker: boolean,
  context?: string,
  dateSelectorParameters?: any | null, 
  setDateSelectorParameters?: Function | null,
  dateIndexSelected?: Array<number> | null,
  setDateIndexSelected?: Function | null,
  loadAnimationTiles?: Function | null,
  initiallyOpen?: boolean,
  loadedTiles?: boolean | null,
  setTimelineStatus?: Function | null,
  timelineStatus?: string | null,
  activeAnimation?: string | null,
  setActiveAnimationFromParent?: Function | null,
  indexA?: number | null,
  setIndexA?: Function | null,
  updateRasterWithNoTimeline?: Function | null,
}

export const LayerVisibilityControlPanel = ({showDatePicker, layers, onChange, context="mapcontrol", dateSelectorParameters=null, setDateSelectorParameters=null, dateIndexSelected=null, setDateIndexSelected=null, initiallyOpen=true, loadAnimationTiles=null, loadedTiles=null, setTimelineStatus=null, timelineStatus=null, activeAnimation=null, setActiveAnimationFromParent=null, indexA=null, setIndexA=null, updateRasterWithNoTimeline=null}: ILayerControlProps) => {
    //console.log("B121224 context", context);
    const { fields } = useFieldStore();
    const { vp, field } = useParams();
    const { createSliderWithTooltip } = Slider;
    const Slider2 = createSliderWithTooltip(Slider.Range);
    //const Slider2 = createSliderWithTooltip(Slider);
    const { Handle } = Slider;
    const handle = (props:any) => {
        const { value, dragging, index, ...restProps } = props;
        return (
          <Tooltip
            prefixCls="rc-slider-tooltip"
            overlay={value}
            visible={dragging}
            placement="top"
            key={index}
          >
            <Handle value={value} {...restProps} />
          </Tooltip>
        );
    };
    const [selectedField, setSelectedField] = useState<any | null>(null);
    const [selected, setSelected] = useState<any | null>(null);
    const [selectedId, setSelectedId] = useState<any | null>(null);
    //const [dateSelectorParameters, setDateSelectorParameters] = useState<any>(null);
    const [selectedCounter, setSelectedCounter] = useState<number>(0);
    const [numberOfXHRRequests, setNumberOfXHRRequests] = useState<number>(0);
    const [previousYear, setPreviousYear] = useState<string | null>(null);
    const [datesAvailable, setDatesAvailable] = useState<Array<string>>([])

    const [selectedDataLayer, setSelectedDataLayer] = useState<LayerVisibility>(_.orderBy([...layers], ['order', ['asc']])[0]);
    const [visibilityDataLayer, setVisibilityDataLayer] = useState<boolean | undefined>(false);
    const [visibility, setVisibility] = useState<LayerVisibility[]>([...layers]);
    const [expanded, setExpanded] = useState<boolean>(initiallyOpen);
    const [findClosestDate, setFindClosestDate] = useState<boolean>(false);
    const [mounted, setMounted] = useState<boolean>(false);
    
    let outstandingYearChange = false;
    let outstandingFieldChange = false;
    let todayDate = new Date();
    const [dateSelected, setDateSelected] = useState<string>( new Date(todayDate.getTime() - (todayDate.getTimezoneOffset() * 60000)).toISOString().split('T')[0]);

    const { settings, updateSettings } = useStore();
    const [year, setYear] = useState(settings[SETTING_SEASON_YEAR]);

    useEffect(() => {
        console.log("BBBB121224 layers", layers);
        console.log("BBBB121224 context", context);
        if (layers.length > 0) {
          const initialLayer = layers.filter((ds: LayerVisibility) => {
            return ds.layer_name === "Productivity";
          })[0];
          const initialVisibility = true; // Toggle this to make "Data Layers:" visible by default
          // Turn the animation timeline on by default
          queueOnVisibilityChange(initialLayer, initialVisibility);
        }
        
      }, []); 

    useEffect(() => {
        console.log("BBBB121224 [layers] layers", layers);
        console.log("BBBB121224 [layers] context", context);
        if (layers.length > 0 && !mounted && visibility?.length > 0) {
          const initialLayer = layers.filter((ds: LayerVisibility) => {
            return ds.layer_name === "Productivity";
          })[0];
          const initialVisibility = true; // Toggle this to make "Data Layers:" visible by default
          // Turn the animation timeline on by default
          console.log("BBBBB121224 initialLayer", initialLayer);
          console.log("BBBBB121224 initialVisibility", initialVisibility);
          queueOnVisibilityChange(initialLayer, initialVisibility);
          setMounted(true);
        }
      }, [layers, visibility]); 

    useEffect(() => {
        console.log("B061324 ---> layers",layers);
        console.log("BBB121224 ---> context, updateRasterWithNoTimeline",context, updateRasterWithNoTimeline);
        if (updateRasterWithNoTimeline){
            console.log("A080923 layers",layers);
            let dateDependentLayers = layers.filter((ds: LayerVisibility) => {
                console.log("A080923 ds",ds);
                return ds.uuid;
            });
            console.log("A080923 dateDependentLayers",dateDependentLayers);
            //
            dateDependentLayers.forEach(function(f:any, index:number) {
                getAvailableDates(f.layer_id,false,"a");
            })
        }
    }, [layers]);

    useEffect(() => {
        if (timelineStatus){
         handleAnimationFrame(dateSelectorParameters.sequence[timelineStatus][0]);
        }
    }, [timelineStatus]);

    useEffect(() => {
        setYear(settings[SETTING_SEASON_YEAR])
    }, [settings]);

    useEffect(() => {
        console.log("BBBB121224 selected, selectedField, context", selected, selectedField, context);
        console.log("BBBB121224 visibility", visibility);
        if ( selected && selectedField){
            outstandingFieldChange = true;
            console.log("080823 A");
            getAvailableDates(selected.layer_id,false,"b")
        }
    }, [selectedField]);

    useEffect(() => {
        console.log("BBB121224 selected", selected);
        if ( selected ){
            outstandingYearChange = true;
            if (selected.source.date_display_resolution){
                if (selected.source.date_display_resolution === 'day'){
                    getAvailableDates(selected.layer_id,false,"c")
                }
            }
        }
    }, [year]);

    useEffect(() => {
        /*console.log("052323 0 dateIndexSelected",dateIndexSelected);
        console.log("052323 0 dateSelectorParameterst",dateSelectorParameters);
        console.log("052323 0 dateSelected",dateSelected);*/
        if (dateIndexSelected && dateSelectorParameters?.min_date){
            let persistedDate = dateSelectorParameters.dates.filter((element:any, index:number) => {
                return element === dateSelected;
            });
            console.log(`052323 0 persistedDate = ` , persistedDate)
            handleAfterSliderChange(dateIndexSelected);
        }
    }, [dateSelectorParameters]);

    useEffect(() => {
        setVisibility([...layers]);
        //console.log("B032124 layers", layers);
        if (!selectedDataLayer){
            setSelectedDataLayer(_.orderBy([...layers], ['order', ['asc']])[0]);
        }
    }, [layers]);

    useEffect(() => {
        console.log("A032124 selectedDataLayer", selectedDataLayer);
    }, [selectedDataLayer]);
  
    // set selected field when the field id is in the url
    useEffect(() => {
        if (fields && field) {
            if (!selectedField || (selectedField.id.toString() !== field.toString())){
                setSelectedField(fields.find((f:any) => f.id == field));
            }
        }
    }, [fields, field]);

    useEffect(() => {
        console.log("D020824 visibility", visibility);
    }, [visibility]);

    useEffect(() => {
        console.log("BB121224 datesAvailable",datesAvailable);
        console.log("080923 visibility",visibility);
        console.log("080923 selectedId",selectedId);
        if(visibility.length > 0){
            let _selectedId = selectedId ? selectedId.id : (selected ? selected.id : visibility[0].layer_id);
            console.log("D081023 visibility",visibility);
            console.log("D081023 selectedId",selectedId);
            console.log("D081023 _selectedId",_selectedId);
            if (typeof selectedId === 'string' && updateRasterWithNoTimeline) { 
                _selectedId = selectedId
            }
            console.log("D081023 _selectedId",_selectedId);
            const dsLayerFiltered = visibility.filter((ds: any) => {
                return ds.id === _selectedId;
            });
            let dsLayer = dsLayerFiltered[0];
            if (dsLayerFiltered.length > 1){
                const dsLayerFind = dsLayerFiltered.find((s:any) => {
                    return s.name === selectedId.disambiguate;
                });
                if (dsLayerFind){ dsLayer = dsLayerFind };
            }
            if(dsLayer) {
                //const layer = layerRef.current;
                //layer?.updateDataSource(dsLayer);
                //setSelected(dsLayer);
                console.log("BB121224 dsLayer", dsLayer);
                createDateSelectorParameters(dsLayer);
                setSelectedCounter((prevState:number) => {
                    return prevState + 1;
                });
                if (updateRasterWithNoTimeline){
                    updateRasterWithNoTimeline(dsLayer,datesAvailable);
                }
                //refresh();
            }else if (updateRasterWithNoTimeline){
                let dsLayerX = visibility.find((s:any) => {
                    console.log("080923 s", s);
                    return s.uuid;
                })
                console.log("080923 dsLayerX", dsLayerX);
                if (dsLayerX) {
                    updateRasterWithNoTimeline(dsLayerX,datesAvailable);
                }
            }
        }
    }, [datesAvailable]);

    //
    const queueOnVisibilityChange = (item: LayerVisibility, value: boolean) => {
        setVisibilityDataLayer(value);
        _.orderBy(visibility, ['order', ['asc']]).map((item: LayerVisibility) => {
            //layer_id === item.layer_id 
            console.log("020824 item", item);
            console.log("020824 value", value);
            if (selectedDataLayer.layer_id === item.layer_id){
                console.log("BBBBB121224 value", value);
                console.log("BBBBB121224 item", item);
                onVisibilityChange(item, value);
            }
        })
    }

    const onSelectDataLayer = (_layer_id: string, event: any) => {
        console.log("C020824 _layer_id", _layer_id);
        console.log("C020824 event", event);
        console.log("C020824 selectedDataLayer", selectedDataLayer);

        // Turn off any visible layers
        let newVisibility = [...visibility]
        newVisibility.map((_item: LayerVisibility) => {
            console.log("C020824 _item", _item);
            let item = _item;
            //if (selectedDataLayer.is_visible){
            if (item.is_visible){
                //onVisibilityChange2ndCol(item, false);
                item.is_visible = false;
            }
            if (item.layer_id === _layer_id){
                if (visibilityDataLayer === true){
                    //onVisibilityChange2ndCol(item, true);
                    item.is_visible = true;
                }
                console.log("B032124 item", item);
                setSelectedDataLayer(item);
            }
        });
        setVisibility(newVisibility);
        onChange(newVisibility);
    }

    const onVisibilityChange = (item: LayerVisibility, value: boolean) => {
        console.log( "BBB121224 item", item);
        console.log( "C020824 value", value);
        const index = visibility.findIndex(({ layer_id }) => layer_id === item.layer_id);
        setSelected(item);
        setSelectedId(item.layer_id);
        //if(item.layer_id !== "ESRI"){
        if(item.source.stac_address){
            console.log("020824 C");
            if (item.source.utility_layer){ // such as UAS Imagery on Edit Field page 
                //outstandingYearChange = true;
                getAvailableDates(item.layer_id, true,"e");
            }else{
                getAvailableDates(item.layer_id,false,"d");
            }
        }

        //createDateSelectorParameters(item);
        if(index > -1) {
        let items = [...visibility];

        const newItem = {
            ...items[index],
        };

        if(item.layer_id === "MAPBOX"){ // Also turn off labels
            const index_labels = visibility.findIndex(({ layer_id }) => layer_id === "ESRI_LABELS");
            const newItem_labels = {
                ...items[index_labels],
            };
            newItem_labels.is_visible = value;
            items[index_labels] = newItem_labels;
        }

        newItem.is_visible = value;
        console.log( "C020824 newItem", newItem);
        console.log( "C020824 value", value);
        items[index] = newItem;
        console.log( "C020824 items", items);
        setVisibility(items);
        onChange(items);
        }
    };

    const onDateChange = (newDate:string) => {
        try {
            console.log(`052323 2 dateSelected = ${dateSelected}`)
            console.log(`052323 2 setDateSelected(${newDate});`)
            setDateSelected(newDate);
            updateSettings("indices_date", JSON.stringify({
                end_date: newDate,
            }));
        } catch(e) {
            console.error(e);
        }
    }

    const getAvailableDates = (_selectedId:string | null, _force_update:boolean = false, caller:string="") => {
        console.log("BBB121224 getAvailableDates <<<<<<<<<<<<<<<<<<<<<> _selectedId, caller", _selectedId, caller);
        console.log("040224 getAvailableDates > caller", caller);
        console.log("040224 selectedField", selectedField);
        var xhr = new XMLHttpRequest()
        if (_selectedId !== "\"naip\""){
            xhr.addEventListener('load', () => {
                if (xhr.responseText.includes("index_not_found_exception") || xhr.responseText.includes("DOCTYPE html")){

                }else{
                    console.log("080823 xhr.responseText", xhr.responseText);

                    let _response = {features: []}
                    try {
                        _response = JSON.parse(xhr.responseText);
                    } catch (error) {
                        console.error(error, xhr.responseText);
                    }
                    setNumberOfXHRRequests((prevState:number) => {
                        return prevState + 1;
                    });
                    

                    let newDatesAvailable:Array<string> = [];
                    let identicalDates = true;
                    console.log("052323 x3 _response.features: ", _response.features);
                    console.log("052323 x3 datesAvailable: ", datesAvailable);
                    let datesAvailableReversed = datesAvailable.slice().reverse();
  
                    _response.features.forEach(function(f:any, index:number) {
                        //console.log("052323 x3 date: ", f.properties.datetime.split('T')[0]);
                        //console.log("052323 x3 datesAvailable[index]: ", datesAvailable[index]);
                        if (datesAvailableReversed[index]){
                            if (f.properties.datetime.split('T')[0] !== datesAvailableReversed[index]){
                                identicalDates = false;
                                console.log("052323 x3 date: ", f.properties.datetime.split('T')[0]);
                                console.log("052323 x3 datesAvailableReversed[index]: ", datesAvailableReversed[index]);
                            }
                        }else{
                            identicalDates = false;
                        }
                        newDatesAvailable.push(f.properties.datetime.split('T')[0])
                    });
                    if (newDatesAvailable.length === 0){
                        if (_response.features){
                            if  (_response.features.length === 0){
                                _force_update = true;
                            }else{
                                newDatesAvailable.push(`${year}-01-01`)
                            }
                        }else{
    
                        }
                        
                    }else{
                        //newDatesAvailable = test_response;
                    }
                    console.log("052323 x3 identicalDates", identicalDates)
                    console.log("052323 x2 year", year)
                    console.log("BB121224 x2 datesAvailable", datesAvailable)
                    console.log("052323 x2 newDatesAvailable", newDatesAvailable)
                    console.log("052323 x2 outstandingYearChange", outstandingYearChange)
                    console.log("052323 x2 outstandingFieldChange", outstandingFieldChange)
                    setFindClosestDate(false);
                    if (datesAvailable.length === 0){ // Presently theres no difference in available dates between Productivity, Stress, and Brightness Index. Only update it the first time.  
                        setDatesAvailable(newDatesAvailable.reverse());
                    }
                    if (outstandingYearChange || outstandingFieldChange ){ // Allow available dates to be updated if a year change has happened
                        if (!identicalDates){
                            setFindClosestDate(true);
                            setDatesAvailable(newDatesAvailable.reverse());
                            outstandingFieldChange = false;
                            outstandingYearChange = false;
                        }
                        
                    }
                    if (_force_update){
                        setFindClosestDate(true);
                        setDatesAvailable(newDatesAvailable.reverse());
                    }
                }
            })
            // TEST/EXAMPLES:
            //let _url = "https://stac-server-test.syncarto.com/collections/185647c4-c577-11ec-93f4-024a2a01d41b-vvi/items"
            //let _url = "https://stac-server-test.syncarto.com/search?bbox=[-121.893310546875,38.66406704456943,-121.8878173828125,38.668356101515066]&datetime=2020-05-29/2023-01-01&collections=185647c4-c577-11ec-93f4-024a2a01d41b-pgi"
            if (_selectedId){
                let dsLayerFiltered: LayerVisibility[];
                if (visibility.length > 0){
                    dsLayerFiltered = visibility.filter((ds: LayerVisibility) => {
                        return ds.layer_id === _selectedId;
                    });
                }else{
                    dsLayerFiltered = [...layers].filter((ds: LayerVisibility) => {
                        return ds.layer_id === _selectedId;
                    });
                }
                if (updateRasterWithNoTimeline){
                    dsLayerFiltered = [...layers].filter((ds: LayerVisibility) => {
                        return ds.uuid;
                    })
                    if (dsLayerFiltered && dsLayerFiltered.length){
                        _selectedId = dsLayerFiltered[0].layer_id;
                    }
                }
                console.log("A080923 dsLayerFiltered", dsLayerFiltered)
                if (dsLayerFiltered && dsLayerFiltered.length){
                    let _url = null//`${dsLayerFiltered[0].source.stac_address}?bbox=[-121.893310546875,38.66406704456943,-121.8878173828125,38.668356101515066]&datetime=${year}-01-01/${year}-12-31&limit=500&collections=${_selectedId}`;
                    if (selectedField){
                        _url = `${dsLayerFiltered[0].source.stac_address}?bbox=[${ bbox(selectedField.geom).toString()}]&datetime=${year}-01-01/${year}-12-31&limit=500&collections=${_selectedId}`;
                    }else{
                        //_url = `${dsLayerFiltered[0].source.stac_address}?bbox=[-121.893310546875,38.66406704456943,-121.8878173828125,38.668356101515066]&datetime=${year}-01-01/${year}-12-31&limit=500&collections=${_selectedId}`;
                    }
                    //console.log(_url)
                    console.log("052323 x3 dsLayerFiltered", dsLayerFiltered)
                    if (_url){
                        xhr.open('GET', _url)
                        xhr.send()
                    }
                }
            }
        }
    }

    const handleFormatSliderChange = (v: any) => {
        var dateFormatted = "";
        let startDate = moment(new Date(dateSelectorParameters.min_date));
        dateFormatted = startDate.add((v + 1), 'days').format("YYYY-MM-DD");
        return dateFormatted;
    }

    /*const handleSliderChange = (evt: any) => {
        console.log("handleSliderChange evt", evt);
        console.log("dateSelected", dateSelected);
    }*/

    const handleAfterSliderChange = (evt: any) => {
        console.log("052323 1 evt",evt);
        if (setActiveAnimationFromParent){
            setActiveAnimationFromParent("not engaged");
        }
        var dateFormatted = "";
        //let startDate = moment(new Date(dateSelectorParameters.min_date));     
        //let startDate = moment.utc(new Date(year/*dateSelectorParameters.max_date*/));
        console.log(`052323 1 dateSelectorParameters = ` , dateSelectorParameters)
        let persistedDate = dateSelectorParameters.dates.filter((element:any, index:number) => {
            return element === dateSelected;
        });
        console.log(`052323 1 persistedDate = ` , persistedDate)
        let startDate = moment.utc(new Date(dateSelectorParameters.min_date));
        //if (persistedDate.length !== 0){
        //    startDate = moment.utc(new Date(persistedDate[0]));
        //}
        dateFormatted = startDate.add((evt[1]), 'days').format("YYYY-MM-DD");
        console.log(`052323 1 dateSelected = ${dateSelected}`)
        console.log(`052323 1 setDateSelected(${dateFormatted});`)
        setDateSelected(dateFormatted);
        onDateChange(dateFormatted);
        /*if (setIndexA && datesAvailable.length){
            let _sequence = dateSelectorParameters.sequence;
            for (let s in _sequence){
                if (_sequence[s][0] === evt[1]){
                    console.log(s)
                    datesAvailable.forEach((d: any, index:number) => {
                        if (d === s){
                            setIndexA(index)
                        }
                    })
                }
            };
        }*/
        if (setDateIndexSelected){
            setDateIndexSelected(evt);
        }
        setSelectedCounter((prevState:number) => {
            return prevState + 1;
        });
    }

    const handleAnimationFrame = (n: any) => {
        if (setDateIndexSelected && dateIndexSelected){
            setDateIndexSelected([dateIndexSelected[0],n,dateIndexSelected[2]]);
        }
    }

    const createDateSelectorParameters = (_dsLayer:any) => {
        console.log("BB121224 createDateSelectorParameters _dsLayer", _dsLayer)
        /*const _max_date = moment(_dsLayer.source.max_date).isAfter(moment(new Date()))
            ? moment(new Date()).format("YYYY-MM-DD") // If provided max is in the future, provide today's date instead.
            : _dsLayer.source.max_date;               //
        const _min_date = datesAvailable[datesAvailable.length -1]; // _dsLayer.source.min_date; //"2022-07-01";//;*/
        /* If we wanted to set max/min dates to only those available (provided by STAC), instead of max/min provided by the layer/source properties.
        const _max_date = datesAvailable[datesAvailable.length -1];
        const _min_date = datesAvailable[0];*/
        console.log("080923 x5 dateSelectorParameters", dateSelectorParameters)
        console.log("080923 x5 _dsLayer", _dsLayer)
        let _prevYear = previousYear;
        setPreviousYear(year);
        console.log("052323 x5 year", year)
        console.log("080923 x5 dateIndexSelected", dateIndexSelected)
        console.log("052323 x5 dateSelectorParameters?.marks[dateIndexSelected ? dateIndexSelected[1] : 0 ]", dateSelectorParameters?.marks[dateIndexSelected ? dateIndexSelected[1] : 0 ])
        let previouslySelectedDate:any = null;
        if (dateSelectorParameters){
            previouslySelectedDate = dateSelectorParameters?.marks[dateIndexSelected ? dateIndexSelected[1] : 0 ]
            //if (setDateIndexSelected){ setDateIndexSelected([0,130,140]) };
        }
        console.log("080923 x5 previouslySelectedDate", previouslySelectedDate)
        const _min_date = datesAvailable[0]; //`${year}-12-31`;
        const _max_date = datesAvailable[datesAvailable.length - 1]; //`${year}-01-01`;
        const _datesPossible = enumerateDaysBetweenDates(_min_date, _max_date);
        let _marks = {};
        let _sequence:any = {};
        let _lastIndex = 0;
        let _firstIndex = -99;
        let _prevSelectedIndex = null;
        let mark31 = false;
        let mark7 = false;
        let markX= true;
        let _leastDifference = { difference: 999, date:{index:0, date:""}};
        _datesPossible.forEach(function(date:string, index:number) {
            if (index%182 == 0){
                markX = true;
            }
            if (index%31 == 0){
                mark31 = true;
            }
            if (index%7 == 0){
                mark7 = true;
            }
            if(datesAvailable[datesAvailable.length -1] === date){
                markX = true;
                mark31 = true;
                mark7 = true;
            }
            if (datesAvailable.includes(date)){
                let mmdd = `${date.split("-")[1]}-${date.split("-")[2]}`

                let dA = moment.utc(new Date(date));
                let dB = moment.utc(new Date(`${year}-${previouslySelectedDate?.props?.children}`));
                //console.log("052323 x5 dA", dA)
                //console.log("052323 x5 dB", dB)
                if (Math.abs(dA.diff(dB, 'days')) < _leastDifference.difference){
                    _leastDifference.difference = Math.abs(dA.diff(dB, 'days'));
                    _leastDifference.date = {index:index, date:date};
                }
                _marks[index] = <div className={`rotateTick90 markOff mark1 ${mark31 ? "mark31 " : ""}${mark7 ? "mark7 " : ""}${markX ? "markX " : ""}`} style={{zIndex:index}} >{mmdd}</div>;
            
                if (mark31){
                    mark31 = false;
                }
                if (mark7){
                    mark7 = false;
                }
                if (markX){
                    markX = false;
                }
                _sequence[date] = [index,mmdd]
                _lastIndex = index;
                if (_firstIndex == -99){
                    _firstIndex = index;
                }
            }
        });
        
        let uniqueDatesAvailable = datesAvailable.filter((element, index) => {
            return datesAvailable.indexOf(element) === index;
        });
        console.log("052323 x6 _leastDifference", _leastDifference)
        console.log("052323 x6 _lastIndex", _lastIndex)
        console.log("052323 x6 _prevSelectedIndex", _prevSelectedIndex)
        console.log("080923 x6 context", context)
        _prevSelectedIndex = _leastDifference.date.index; // If the season has changed, set the index to the closest date in the new year.
        //_prevSelectedIndex = _prevYear === year ? _leastDifference.date.index : _lastIndex; // If the season has changed, set the index to the end of the season.
        if (setDateIndexSelected){ setDateIndexSelected( [_firstIndex, _prevSelectedIndex ? _prevSelectedIndex : _lastIndex, _lastIndex] ); }

        //console.log("dateSelectorParameters _marks ", _marks );
        const _params = {
            totalDays: _datesPossible.length,
            max_date: _max_date, //_dsLayer.source.max_date,
            min_date: _min_date, //_min_date,//_dsLayer.source.min_date,
            marks:_marks,
            sequence:_sequence,
            dates: uniqueDatesAvailable,
        }
        console.log("BB121224 _params", _params)
        if (setDateSelectorParameters){
            console.log("080923 x1 setDateSelectorParameters", _params)
            setDateSelectorParameters( _params )
        };
    }

    const enumerateDaysBetweenDates = function(_startDate:string, _endDate:string) {
        var dates = [];
        let startDate = moment.utc(new Date(_startDate));
        let endDate = moment.utc(new Date(_endDate));
        endDate = endDate.add(1, 'days');
        while(startDate.format('YYYY-MM-DD') !== endDate.format('YYYY-MM-DD')) {
            dates.push(startDate.format('YYYY-MM-DD'));
            startDate = startDate.add(1, 'days');
        }
        dates.push(startDate.format('YYYY-MM-DD'));
        startDate = startDate.add(1, 'days');
        dates.push(startDate.format('YYYY-MM-DD'));
        console.log("062023 dates",dates)
        return dates;
    };

    const playAnimation = function(event:any){      
        if (setActiveAnimationFromParent){
           setActiveAnimationFromParent("playing");
        }
        if (loadAnimationTiles){
            console.log("dateSelectorParameters",dateSelectorParameters)
            loadAnimationTiles(dateSelectorParameters)
        }
    };

    const pauseAnimation = function(event:any){
        if (setActiveAnimationFromParent){
            setActiveAnimationFromParent("paused");
        }
    };

    return (
        <>
        {expanded ?
        <div 
            key={"soilsLayerVisControlParent"} 
            className={`control-panel text-dark ${(context==="sidebar") ? "" : "shadow-sm rounded-lg"} position-relative`} 
            style={{
                display: (context==="timeline" && !dateSelectorParameters) ? 'none' : 'block', 
                paddingLeft: (context==="sidebar") ? '12px' : (context==="timeline") ? '10px' : '5px', 
                paddingRight:(context==="sidebar") ? '12px' : (context==="timeline") ? '10px' : '5px', 
                paddingTop:'5px', 
                paddingBottom:'5px', 
                width: (context==="sidebar" || context==="timeline" ) ? "100%" : "180px", 
                margin: 0, 
                top: 'unset', 
                bottom: 'unset', 
                left: 'unset', 
                right: 'unset', 
                height: (context==="timeline" ) ? "100%" : "unset",
                backgroundColor: (context==="timeline" ) ?'transparent' : 'white', 
                pointerEvents:'all',
                cursor: 'pointer',
            }}
        >  
            {(context != "timeline")
            ? <>
                <div 
                    key={"soilsKeyDiv"} 
                    style={{ 
                        cursor: 'pointer', 
                        paddingBottom:'0px', 
                        width: (context==="sidebar" || context==="timeline" ) ? '100%' : '25px', 
                        textAlign: (context==="sidebar") ? 'left' : 'center', 
                        position: (context==="sidebar") ? 'unset' : (context==="mapcontrol") ? 'absolute' : 'relative', 
                        right: (context==="sidebar") ? 'unset' : '0px'}} 
                    onClick={() => setExpanded(false)}
                >
                    <span key={"soilsKeySpan"}>{(context==="sidebar") ? "Data Layers:" : ""}</span>
                    <FontAwesomeIcon key={"soilsKeyIcon"} style={{float: (context==="sidebar") ? 'right' : 'unset'}} icon={faChevronDown} />
                </div>
                {(context != "sidebar") 
                ? _.orderBy(visibility, ['order', ['asc']]).map((item: LayerVisibility) => (
                        console.log("A050524 item", item),
                        <div key={`${item.layer_id}-key-div-parent`}>
                        <div key={`${item.layer_id}-key-div`} 
                            className="form-check" 
                            style={{width:'calc(100% - 25px)', 
                            display: `${(item.layer_id === "ESRI_LABELS") ? 'none' : 'block'}`}}>
                            <input
                                key={`${item.layer_id}_input_key`}
                                id={item.layer_id}
                                className="form-check-input"
                                type="checkbox"
                                checked={item.is_visible}
                                onChange={evt => onVisibilityChange(item, evt.target.checked)}
                            />
                            <label 
                                key={item.layer_id} 
                                htmlFor={item.layer_id} 
                                className="form-check-label text-sm">{item.layer_name}</label>
                        </div>
                        {(context === "sidebar" && item.is_visible )
                            ? <div style={{width: "100%", height: 40, textAlign: "center", }}>
                                    <Gradient width={165} height={15} ramp={JSON.parse(item.source.color_ramp)} inverse={false} />
                                    <br/>
                                    <div style={{height: 15, width:165, display:'inline-block', position: 'relative', top: '-5px'}}>
                                        <div style={{float:'left', fontSize:'8pt'}}>{item.source.global_min.toString()}</div>
                                        <div style={{float:'right', fontSize:'8pt'}}>{item.source.global_max.toString()}</div>
                                    </div>
                                </div>
                            : null
                        }
                        </div>
                    ))
                : <>
                    <div key={`k-key-div-parent_${context}`}>
                        <div 
                            key={`k-key-div_${context}`} 
                            className="form-check" 
                            style={{
                                width:'calc(100%)', 
                                display: 'block' //`${("item.layer_id" === "ESRI_LABELS") ? 'none' : 'block'}`}}
                            }}  
                        >
                            <input
                                key={`k-key_${context}`}
                                id={"item.layer_id"}
                                className="form-check-input"
                                type="checkbox"
                                checked={visibilityDataLayer}
                                style={{marginTop: "8px"}}
                                onChange={evt => queueOnVisibilityChange(selectedDataLayer, evt.target.checked)}
                            />
                            <div key={`a_key_${context}`} className="d-flex flex-column" style={{marginTop: "10px", marginBottom:"10px"}}>
                                <DropdownButton 
                                    as={ButtonGroup}
                                    key={`b_key_${context}`}
                                    id="data-layer-selector"
                                    variant="light"
                                    size="sm"
                                    onSelect={(key:any, e:any) => onSelectDataLayer(key, e)}
                                    title={`${selectedDataLayer ? selectedDataLayer.layer_name : ""}`}>
                                    {_.orderBy(visibility, ['order', ['asc']]).map((item: LayerVisibility) => (
                                        console.log("032124 item", item),
                                        <Dropdown.Item 
                                            key={item.layer_id}
                                            eventKey={item.layer_id}

                                        >{item.layer_name}</Dropdown.Item>
                                    )  
                                )}
                                </DropdownButton>
                            </div>
                            { _.orderBy(visibility, ['order', ['asc']]).map((item: LayerVisibility) => (
                            (item.is_visible )
                            ? <div key={`c_c_key_${item.uuid}`} style={{width: "100%", height: 40, textAlign: "center",paddingTop:"0px", paddingBottom:"0px" }}>
                                    <Gradient key={`d_key_${item.uuid}`} width={200} height={15} ramp={JSON.parse(item.source.color_ramp)} inverse={false} />
                                    <br/>
                                    <div key={`e_key_${item.uuid}`} style={{height: 15, width:200, display:'inline-block', position: 'relative', top: '-5px'}}>
                                        <div key={`f_key_${item.uuid}`} style={{float:'left', fontSize:'8pt'}}>{item.override_max_min ? item.override_max_min[0].toString() : item.source.global_min.toString()}</div>
                                        <div key={`g_key_${item.uuid}`} style={{float:'right', fontSize:'8pt'}}>{item.override_max_min ? item.override_max_min[1].toString() : item.source.global_max.toString()}</div>
                                    </div>
                                </div>
                            : null
                            ))
                        }
                    </div>
                    </div>
                </>}
            </>
            :<></>
            }
            {console.log("B121224 dateSelectorParameters, context", dateSelectorParameters, context)}
            {dateSelectorParameters && dateSelectorParameters.totalDays > 0 && (context == "timeline")
            ? <div style={{
                display:"flex",
                bottom:"5px",
                height:'65px',
                position: 'absolute',
                width:"calc(100% - 20px)",
                paddingLeft: "15px",
                backgroundColor: 'white',
                borderRadius: '0.3rem',
            }}>
                <div style={{display:"block", width: "100%", paddingRight: "5px"}}>
                    <div style={{marginRight:"0px", marginTop:"5px"}}>
                        <Slider2
                                key={selectedCounter}
                                style={{marginBottom:"25px"}}
                                //count={3}
                                min={0}
                                max={dateSelectorParameters.totalDays}
                                defaultValue={dateIndexSelected}
                                marks={dateSelectorParameters.marks}
                                handle={handle}
                                tipFormatter={handleFormatSliderChange}
                                //onChange={(e: any) => handleAfterSliderChange(e)} 
                                onAfterChange={(e: any) => handleAfterSliderChange(e)} 
                                step={null}
                                handleStyle={[
                                    { backgroundColor: "#ffffff00", borderRadius: '0.5px', border: '2px solid #6c757d', width:'10px', height:'20px', borderRight: 'none', marginLeft:'-4.5px', marginTop:'-8.5px', zIndex: 40 },
                                    { backgroundColor: "#6c757d", height:'20px', width:'20px', marginTop:'-8.5px', zIndex: 50 },
                                    { backgroundColor: "#ffffff00", borderRadius: '0.5px', border: '2px solid #6c757d', width:'10px', height:'20px', borderLeft: 'none', marginLeft:'4.5px', marginTop:'-8.5px', zIndex: 41 }
                                ]}
                        />
                    </div>
                </div>
                <div
                    className="rounded-lg shadow-sm"
                    style={{/*height: "60px",*/ width: "60px", backgroundColor: "#fff", color:"#666"}}
                >
                    <div
                        style={{width: "60px", height: "50px", textAlign:"center", marginTop:"7px", cursor:"pointer", pointerEvents: "all"}}
                        onClick={(e:any) => {
                            if (activeAnimation === "playing"){
                                pauseAnimation(e);
                            }else{
                                playAnimation(e);
                            }
                        }}
                    >
                    { loadedTiles 
                        ? (activeAnimation === "playing")
                            ? <>
                                <FontAwesomeIcon icon={faPause} />
                                <div
                                    style={{width: "60px", height: "30px", textAlign:"center", fontSize: "12px", marginTop:"7px"}}
                                >
                                    Pause
                                </div>
                            </>
                            : <>
                                <FontAwesomeIcon icon={faPlay} />
                                <div
                                    style={{width: "60px", height: "30px", textAlign:"center", fontSize: "12px", marginTop:"7px"}}
                                >
                                    Animate
                                </div>
                            </>
                        : <LoadingSpinnerSmall message="Loading..."></LoadingSpinnerSmall>
                    }
                    </div>
                </div>
            </div>
            
            : (context == "timeline")
                ?<div style={{
                    backgroundColor: "#ffffff99",
                    lineHeight: "30px",
                    textAlign: "center",
                    position: "relative",
                    top: "68px",
                    borderRadius: "4px",
                }}
                >No data for requested time range.  Please try a different season.</div>
                : <></>
        }
        </div>
        : (context === "mapcontrol")
        ? <div onClick={() => setExpanded(true)} className="control-panel text-dark shadow-sm rounded-lg border position-relative" style={{padding:'5px', width:"35px", height:"35px", margin: 0, textAlign:'center', cursor:'pointer', top: 'unset', bottom: 'unset', left: 'unset', right: 'unset'}}><FontAwesomeIcon icon={faLayerGroup} /></div>
        : <div onClick={() => setExpanded(true)} className="control-panel text-dark position-relative" style={{paddingLeft:'12px', paddingRight:'12px', paddingTop:'5px', paddingBottom:'5px', width:"100%", height:"35px", margin: 0, textAlign:'center', cursor:'pointer', top: 'unset', bottom: 'unset', left: 'unset', right: 'unset'}}>
            <span style={{float:"left"}}>{(context != "sidebar") ? "Data Layers:" : "Overlay Layers:"}</span>
            <FontAwesomeIcon style={{float:"right"}} icon={faChevronUp} />
        </div>
        }
        </>
    );
}

export default React.memo(LayerVisibilityControlPanel);
